import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useMemo, useState } from 'react';
var countGroups = function countGroups(opts) {
  return new Set(opts.map(function (it) {
    return it.group;
  }).filter(function (it) {
    return it !== undefined;
  })).size;
};
export var useSelectOptionsFilter = function useSelectOptionsFilter(_ref) {
  var options = _ref.options,
    searchText = _ref.searchText,
    groupLabels = _ref.groupLabels,
    _ref$debounceMs = _ref.debounceMs,
    debounceMs = _ref$debounceMs === void 0 ? 200 : _ref$debounceMs;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    debouncedTextFilter = _useState2[0],
    setDebouncedTextFilter = _useState2[1];
  useEffect(function () {
    var apply = function apply(value) {
      setDebouncedTextFilter(value.toLocaleLowerCase());
    };
    var timeoutId;
    if (debounceMs) {
      timeoutId = setTimeout(function () {
        apply(searchText);
      }, debounceMs);
    } else {
      apply(searchText);
    }
    return function () {
      return timeoutId && clearTimeout(timeoutId);
    };
  }, [searchText, debounceMs]);
  var filteredOptions = useMemo(function () {
    var _getNodeText = function getNodeText(node) {
      if (!node) return '';
      if (node instanceof Array) return node.map(_getNodeText).join('');
      if (_typeof(node) === 'object') return _getNodeText(node.props.children);
      return node.toString();
    };
    if (debouncedTextFilter) {
      var lowercaseSearchText = debouncedTextFilter.toLowerCase();
      return options.filter(function (o) {
        return _getNodeText(o.label).toLowerCase().includes(lowercaseSearchText);
      });
    }
    return options;
  }, [options, debouncedTextFilter]);
  var allGroupLabels = useMemo(
  // Labels must be created from ALL the options or the groups cannot match the index
  function () {
    return groupLabels || new Array(countGroups(options)).fill('');
  }, [groupLabels, options]);
  var currentIndex = 0;
  var groups = useMemo(function () {
    return allGroupLabels.map(function (groupLabel, labelIndex) {
      return {
        groupLabel: groupLabel,
        groupIndex: labelIndex,
        items: filteredOptions.filter(function (x) {
          return x.group === labelIndex;
        }).map(function (item) {
          var indexedItem = _objectSpread(_objectSpread({}, item), {}, {
            index: currentIndex
          });
          currentIndex += 1;
          return indexedItem;
        })
      };
    });
  }, [allGroupLabels, filteredOptions]);
  var sortedFilteredOptions = useMemo(function () {
    if (groups.length < 1) {
      return filteredOptions;
    }
    return groups.flatMap(function (group) {
      return group.items;
    });
  }, [groups, filteredOptions]);
  return {
    groups: groups,
    allGroupLabels: allGroupLabels,
    sortedFilteredOptions: sortedFilteredOptions
  };
};